// extracted by mini-css-extract-plugin
module.exports = {"docsContent":"index-module--docsContent--1vV6X","bottomCallout":"index-module--bottomCallout--2zeY5","docsTopic":"index-module--docsTopic--1-czr"};